import React from 'react';

const SignIn = React.lazy(() =>
  import(/* webpackChunkName: "sign-in" */ '../pages/authentication/SignIn')
);

const ForgotPassword = React.lazy(() =>
  import(
    /* webpackChunkName: "forgot-password" */ '../pages/authentication/ForgotPassword'
  )
);

const ResetPassword = React.lazy(() =>
  import(
    /* webpackChunkName: "reset-password" */ '../pages/authentication/ResetPassword'
  )
);

const SignInVerify = React.lazy(() =>
  import(
    /* webpackChunkName: "signin-Verify" */ '../pages/authentication/SignInVerify'
  )
);

export default [
  {
    id: 'sign-in',
    path: '/auth',
    name: 'Sign In',
    exact: true,
    component: SignIn,
    excludeFromSidebar: true,
  },
  {
    id: 'sign-in-verify',
    path: '/auth/verify',
    name: 'Sign In Verify',
    exact: true,
    component: SignInVerify,
    excludeFromSidebar: true,
  },
  {
    id: 'forgot-password',
    path: '/auth/forgotpassword',
    name: 'Forgot Password',
    exact: true,
    component: ForgotPassword,
    excludeFromSidebar: true,
  },
  {
    id: 'reset-password',
    path: '/auth/reset/:token',
    name: 'Reset Password',
    component: ResetPassword,
    excludeFromSidebar: true,
  },
];
